import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Carousel,
} from "react-bootstrap";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useMediaQuery } from "react-responsive";

import facingBg from "../../images/facing-background.webp";

const floorPlans = [
  {
    id: "TYPE 1",
    title: "2BHK",
    size: "1295 sft East-Facing",
    image: "/fpt1.png",
    download_image : "/type1.png",
    points: [
      "Vaastu-Compliant",
      "Designed To Maximize Space",
      "Natural Light",
      "Privacy",
    ],
  },
  {
    id: "TYPE 2",
    title: "2BHK",
    size: "1295 sft West-Facing",
    image: "/fpt2.png",
    download_image : "/type2.png",
    points: [
      "Vaastu-Compliant",
      "Designed To Maximize Space",
      "Natural Light",
      "Privacy",
    ],
  },
  {
    id: "TYPE 3",
    title: "3BHK",
    size: "1595 sft East-Facing",
    image: "/fpt3.png",
    download_image : "/type3.png",
    points: [
      "Vaastu-Compliant",
      "Designed To Maximize Space",
      "Natural Light",
      "Privacy",
    ],
  },
  {
    id: "TYPE 4",
    title: "3BHK",
    size: "1595 sft East-Facing",
    image: "/fpt4.png",
    download_image : "/type4.png",
    points: [
      "Vaastu-Compliant",
      "Designed To Maximize Space",
      "Natural Light",
      "Privacy",
    ],
  },
  {
    id: "TYPE 5",
    title: "3BHK",
    size: "1595 sft North-Facing",
    image: "/fpt5.png",
    download_image : "/type5.png",
    points: [
      "Vaastu-Compliant",
      "Designed To Maximize Space",
      "Natural Light",
      "Privacy",
    ],
  },
  {
    id: "TYPE 6",
    title: "3BHK",
    size: "1895 sft East-Facing",
    image: "/fpt6.png",
    download_image : "/type6.png",
    points: [
      "Vaastu-Compliant",
      "Designed To Maximize Space",
      "Natural Light",
      "Privacy",
    ],
  },
  {
    id: "TYPE 7",
    title: "3BHK",
    size: "1895 sft West-Facing",
    image: "/fpt7.png",
    download_image : "/type7.png",
    points: [
      "Vaastu-Compliant",
      "Designed To Maximize Space",
      "Natural Light",
      "Privacy",
    ],
  },
  {
    id: "TYPE 8",
    title: "3BHK",
    size: "1895 sft South East-Facing",
    image: "/fpt8.png",
    download_image : "/type8.png",
    points: [
      "Vaastu-Compliant",
      "Designed To Maximize Space",
      "Natural Light",
      "Privacy",
    ],
  },
  {
    id: "TYPE 9",
    title: "3BHK",
    size: "1895 sft West-Facing",
    image: "/fpt9.png",
    download_image : "/type9.png",
    points: [
      "Vaastu-Compliant",
      "Designed To Maximize Space",
      "Natural Light",
      "Privacy",
    ],
  },
  {
    id: "TYPE 10",
    title: "3BHK",
    size: "2195 sft East-Facing",
    image: "/fpt10.png",
    download_image : "/type10.png",
    points: [
      "Vaastu-Compliant",
      "Designed To Maximize Space",
      "Natural Light",
      "Privacy",
    ],
  },
  {
    id: "TYPE 11",
    title: "3BHK",
    size: "2195 sft East-Facing",
    image: "/fpt11.png",
    download_image : "/type11.png",
    points: [
      "Vaastu-Compliant",
      "Designed To Maximize Space",
      "Natural Light",
      "Privacy",
    ],
  },
  {
    id: "TYPE 12",
    title: "3BHK",
    size: "2195 sft West-Facing",
    image: "/fpt12.png",
    download_image : "/type12.png",
    points: [
      "Vaastu-Compliant",
      "Designed To Maximize Space",
      "Natural Light",
      "Privacy",
    ],
  },
  {
    id: "TYPE 13",
    title: "3BHK",
    size: "1495 sft East-Facing",
    image: "/fpt13.png",
    download_image : "/type13.png",
    points: [
      "Vaastu-Compliant",
      "Designed To Maximize Space",
      "Natural Light",
      "Privacy",
    ],
  }
];

const Facing = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 991px)" });

  const [mobileIndex, setMobileIndex] = useState(0);

  const mobileSlides = [];
  for (let i = 0; i < floorPlans.length; i += 4) {
    mobileSlides.push(floorPlans.slice(i, i + 4));
  }

  return (
    <section
      id="facing"
      className="facing-section"
      style={{
        backgroundImage: `url(${facingBg})`,
      }}
    >
      <Container>
        {/* Heading */}
        <div
          className={`heading-wrapper ${isMobile ? "text-start" : "text-center"
            }`}
        >
          {!isMobile ? 
          <h1>IRA Aspiration: Spacious 2 & 3 BHK Homes</h1> : 
          <h1 className="px-3">IRA Aspiration: <br/>Spacious 2 & 3 BHK <br/>Homes</h1>}

          <p className="py-2 px-3 lh-base">Designed For Comfort And Function</p>
        </div>

        {/* Desktop */}
        {!isMobile ? (
          <Carousel
          className="px-5"
            indicators={false}
            interval={null}
            wrap={true}
            nextIcon={
              <div className="custom-arrow custom-arrow-right">
                <FaChevronRight />
              </div>
            }
            prevIcon={
              <div className="custom-arrow custom-arrow-left">
                <FaChevronLeft />
              </div>
            }
          >
            {Array.from({
              length: Math.ceil(floorPlans.length / 3),
            }).map((_, slideIndex) => (
              <Carousel.Item key={slideIndex}>
                <Row className="justify-content-center g-4">
                  {floorPlans
                    .slice(slideIndex * 3, slideIndex * 3 + 3)
                    .map((item, index) => (
                      <Col lg={4} key={index}>
                        <FloorCard item={item} />
                      </Col>
                    ))}
                </Row>
              </Carousel.Item>
            ))}
          </Carousel>

        ) : (
          <>
            {/* Mobile Carousel */}
            <Carousel
              activeIndex={mobileIndex}
              onSelect={(selectedIndex) =>
                setMobileIndex(selectedIndex)
              }
              wrap={true}
              loop={false}
              indicators={false}
              controls={false}
              interval={null}
            >
              {mobileSlides.map((slide, slideIndex) => (
                <Carousel.Item key={slideIndex}>
                  <Row className="g-3">
                    {slide.map((item, index) => (
                      <Col xs={6} key={index}>
                        <FloorCard item={item} mobile />
                      </Col>
                    ))}
                  </Row>
                </Carousel.Item>
              ))}
            </Carousel>

            {/* Mobile Arrows */}
            <div className="mobile-arrows">
              <button
                onClick={() =>
                  setMobileIndex((prev) =>
                    prev === 0
                      ? mobileSlides.length - 1
                      : prev - 1
                  )
                }
              >
                <FaChevronLeft />
              </button>

              <button
                onClick={() =>
                  setMobileIndex((prev) =>
                    prev === mobileSlides.length - 1
                      ? 0
                      : prev + 1
                  )
                }
              >
                <FaChevronRight />
              </button>

            </div>
          </>
        )}
      </Container>
    </section>
  );
};

const FloorCard = ({ item, mobile }) => {
  return (
    <div className={`floor-card ${mobile ? "mobile-card" : ""}`}>
      <div className="type-badge">{item.id}</div>

      <img src={item.image} alt={item.title} />

      <div className="floor-content">
        <h3>{item.title}</h3>

        <h5>{item.size}</h5>

        <ul>
          {item.points.map((point, idx) => (
            <li key={idx}>{point}</li>
          ))}
        </ul>

        <button>
          <a
            href={item.download_image}
            download
          >
            Download Floor Plan
          </a>
        </button>
      </div>
    </div>
  );
};

export default Facing;